//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfPTextValidation",
    props: {
        valueToggle: { type: Boolean, default: false },
        valueErrMsg: { type: String, default: "" },
        label: { type: String, default: "" },
        labelErrMsg: { type: String, default: "" },
        tooltip: { type: String, default: "" },
        disable: { type: Boolean, default: false },
        lengthValidation: { type: Boolean, default: false },
        minLength: { type: Number, default: null },
        maxLength: { type: Number, default: null },
        fromRange: { type: Boolean, default: false }
    },
    computed: {
        localValue: {
            get() {
                return this.valueToggle;
            },
            set(val) {
                this.$emit("toggleChange", val);
            }
        },
        minLengthValue: {
            get() {
                return this.minLength;
            },
            set(val) {
                this.$emit("minLengthValue", val ? Number(val) : undefined);
            }
        },
        maxLengthValue: {
            get() {
                return this.maxLength;
            },
            set(val) {
                this.$emit("maxLengthValue", val ? Number(val) : undefined);
            }
        },
        errMsgValue: {
            get() {
                return this.valueErrMsg;
            },
            set(val) {
                this.$emit("errMsgChange", val);
            }
        }
    },
    methods: {
    }
};
